import type { ReactNode } from "react";

type Tone = "accent" | "muted" | "onDark" | "onDarkPrimary" | "solid";

const TONES: Record<Tone, string> = {
  accent: "text-accent-600",
  muted: "text-foreground-500",
  onDark: "text-accent-400",
  onDarkPrimary: "text-primary-500",
  solid: "text-foreground-800",
};

interface EyebrowProps {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}

/**
 * Section-level small label. Always bracketed, always the same size,
 * tracking and weight — so every section reads as part of one system.
 */
export default function Eyebrow({ children, tone = "accent", className = "" }: EyebrowProps) {
  return (
    <p
      className={`font-label text-[11px] uppercase tracking-[0.2em] font-semibold ${TONES[tone]} ${className}`}
    >
      [ {children} ]
    </p>
  );
}